module.exports = __webpack_public_path__ + "static/vasano_frame2.8886e38b.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/animation/vasano_frame2.gif
// module id = ./assets/animation/vasano_frame2.gif
// module chunks = 170844033123148